import React from 'react';
import { siteConfig } from '../../config/siteConfig';
import './Festivals.css';

const Festivals = () => {
  const { festivals } = siteConfig;

  // Helper function to convert hex to rgba with configurable opacity
  const hexToRgba = (hex, opacity) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  return (
    <section className="festivals">
      {festivals.showTitle && (
        <div className="festivals-title">
          <h2>{festivals.title}</h2>
        </div>
      )}
      
      <div className="festivals-grid">
        {festivals.items.map((festival, index) => (
          <div
            key={index}
            className="festival-item"
          >
            {/* Background image - always visible */}
            <div className="festival-background">
              <img
                src={festival.backgroundImage.src}
                alt={festival.backgroundImage.alt}
                loading="lazy"
              />
            </div>
            
            {/* Color overlay with blur */}
            <div 
              className="festival-overlay"
              style={{
                backgroundColor: hexToRgba(festival.backgroundColor, festivals.opacity)
              }}
            />
            
            {/* Logo for default state */}
            <div className="festival-logo">
              <img
                src={festival.logo.src}
                alt={festival.logo.alt}
                loading="lazy"
              />
            </div>
            
            {/* Content overlay for hover state */}
            <div className="festival-content">
              <h3 className="festival-title">{festival.title}</h3>
              <p className="festival-description">{festival.description}</p>
              <a
                href={festival.url}
                target="_blank"
                rel="noopener noreferrer"
                className="festival-button"
              >
                {festival.buttonText}
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Festivals; 